// extracted by mini-css-extract-plugin
export default {"logo":"l9","cancel":"m9","stickyheader":"n9","buttonswrap":"o9","item":"p9","starterKit":"q9","boldHeader":"r9","reviewheader":"s9","text":"t9","username":"u9"};
    if(module.hot) {
      // 1715632479596
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  